/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyStepsDTO
 */
export interface SurveyStepsDTO {
    /**
     * 
     * @type {number}
     * @memberof SurveyStepsDTO
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyStepsDTO
     */
    prefilledEmailOptionsId: number | null;
    /**
     * 
     * @type {number}
     * @memberof SurveyStepsDTO
     */
    parentId: number | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyStepsDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyStepsDTO
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyStepsDTO
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyStepsDTO
     */
    action: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyStepsDTO
     */
    actionHref: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyStepsDTO
     */
    actionTitle: string;
}

export function SurveyStepsDTOFromJSON(json: any): SurveyStepsDTO {
    return SurveyStepsDTOFromJSONTyped(json, false);
}

export function SurveyStepsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyStepsDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'prefilledEmailOptionsId': json['prefilled_email_options_id'],
        'parentId': json['parent_id'],
        'name': json['name'],
        'description': json['description'],
        'order': json['order'],
        'action': json['action'],
        'actionHref': json['action_href'],
        'actionTitle': json['action_title'],
    };
}

export function SurveyStepsDTOToJSON(value?: SurveyStepsDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'prefilled_email_options_id': value.prefilledEmailOptionsId,
        'parent_id': value.parentId,
        'name': value.name,
        'description': value.description,
        'order': value.order,
        'action': value.action,
        'action_href': value.actionHref,
        'action_title': value.actionTitle,
    };
}

